// Watch the Hello Bar for changes in height and update the CSS custom property accordingly.
export function helloBar()
{
	const helloBar = document.querySelector('.jsHelloBar');
	if (helloBar)
	{
		const observer = new ResizeObserver(entries =>
		{
			for (let entry of entries)
			{
				const newHeight = entry.target.clientHeight;
				document.documentElement.style.setProperty('--helloBarHeight', newHeight + 'px');

			}
		});
		observer.observe(helloBar);
	}
	else
	{
		document.documentElement.style.setProperty('--helloBarHeight', 0 + 'px');
	}
}